
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { authKey, GET_INVENTORY_ISSUE_LIST, CLOSE_INVENTORY_ISSUE } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Container, Card, CardContent, Tooltip, IconButton, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { UpdateIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function InventoryIssueList() {

    const navigate = useNavigate();
    const [inventoryIssueList, setInventoryIssueList] = useState();
    const [closeInventoryIssue, setCloseInventoryIssue] = useState();

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);


    useEffect(() => {
        getInventoryIssueList();

    }, []);

    const getInventoryIssueList = (e) => {
        loaderService.showLoader()
        apiClient
            .post(GET_INVENTORY_ISSUE_LIST,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setInventoryIssueList(response.data.inventoryIssueList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const columns = [
        { field: 'stakeholderType', headerName: 'Stakeholder', width: 160 },
        { field: 'stakeholderUrn', headerName: 'URN', width: 150 },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
        { field: 'issueNumber', headerName: 'Issue Number', width: 160 },
        { field: 'issueNumberStatus', headerName: 'Status', width: 150 },
        { field: 'pickupNetWeight', headerName: 'Pickup Weight', width: 150 },
        { field: 'destinationNetWeight', headerName: 'Destination Weight', width: 150 },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 150 },
        {
            field: 'Action', width: 120,
            renderCell: (params) => {
                return (
                    <Tooltip title="Update">
                    <IconButton
                        variant="contained"
                        color="primary"
                        onClick={() => onUpdate(params.row)}
                    >
                        <UpdateIcon />
                    </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const onConfirmUpdate = (e) => {
        handleConfirmClose();
        onUpdate();
        // onSubmit(e);
    }

    const onUpdateButtonClick = (row) => {
        handleConfirmOpen(row);
    }

    const onUpdate = (row) => {
        loaderService.showLoader()
        apiClient
            .post(CLOSE_INVENTORY_ISSUE,
                {
                    "stakeholderType": row.stakeholderType,
                    "stakeholderUrn": row.stakeholderUrn,
                    "bundleId": row.bundleId,
                    "issueNumber": row.issueNumber,
                    "materialType": row.materialType,
                    "qualityParameter": row.qualityParameter,
                    "actualValue": row.actualValue,
                    "recordedValue": row.recordedValue,
                    "postInspectionValue": '',
                    "toleranceLimit": '',
                    "maximumLimit": '',
                    "minimumLimit": '',
                    "comment": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setCloseInventoryIssue(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (closeInventoryIssue) {
            if (closeInventoryIssue.isSuccess === true) {
                toast.success(closeInventoryIssue?.message);

            }
            else {
                toast.error(closeInventoryIssue?.message ? closeInventoryIssue?.message : "Error");
            }
        }
    }, [closeInventoryIssue]);


    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h5" gutterBottom>
                    Inventory Issue List
                </Typography>
                <Card>
                    <CardContent>
                        <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                            {
                                inventoryIssueList &&
                                <DataGrid rows={inventoryIssueList}
                                    columns={columns}
                                    pageSize={10}
                                    getRowId={(row) => row.issueNumber}
                                    components={{ Toolbar: QuickSearchToolbar }}

                                />
                            }

                        </Box>
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmUpdate} onClose={handleConfirmClose} action="Update" />
        </>
    );
}
export default InventoryIssueList;
